import React, { useMemo } from "react";
import { SectionPaper } from "./Papers";
import { Grid2 as Grid } from "@mui/material";
import { singleGridItem } from "../forms/fields/defaultStyles";
import { FieldValues, useFormContext } from "react-hook-form";

interface SectionsWrapperProps<T extends FieldValues> {
  sections: (data: T) => React.ReactElement[];
}

const SectionsWrapper = <T extends FieldValues>({
  sections,
}: SectionsWrapperProps<T>) => {
  const { getValues } = useFormContext<T>();
  const values = getValues();

  const renderedSections = useMemo(() => {
    return sections(values).map((section, index) => (
      <SectionPaper key={index}>{section}</SectionPaper>
    ));
  }, [values, sections]);

  return (
    <Grid container {...singleGridItem}>
      <Grid {...singleGridItem}>{renderedSections}</Grid>
    </Grid>
  );
};

export default SectionsWrapper;
